import { createContext, Dispatch, FunctionComponent, useReducer } from 'react';

import { PlaygroundState, playgroundInitState, playgroundReducer } from '@playground/context/state';
import { Exercise } from '@playground/models/exercise.model';

const initState: PlaygroundState = playgroundInitState();

export const PlaygroundContext = createContext<{
  state: PlaygroundState;
  dispatch: Dispatch<unknown>;
}>({ state: initState, dispatch: () => null });

interface Props {
  children: any;
  exercise: Exercise;
  mode: 'embed' | 'external';
}

const PlaygroundProvider: FunctionComponent<Props> = ({ children, exercise, mode }) => {
  const [state, dispatch] = useReducer(playgroundReducer, {
    ...initState,
    exercise,
    runner: {
      ...initState.runner,
      mode,
    },
  });
  const value = { state, dispatch };
  return <PlaygroundContext.Provider value={value}>{children}</PlaygroundContext.Provider>;
};

export default PlaygroundProvider;
